<template>
  <!--class="container-fluid"-->
  <div id="app">

    <notifications position="top center" classes="alert sk-notification" width="80%">
      <template slot="body" slot-scope="props">
        <div v-bind:class="'alert sk-notification d-print-none ' + props.item.type">
          <button type="button" class="close" @click="props.close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-if="props.item.title" class="alert-heading"> {{props.item.title}} </h4>
          <span v-html="props.item.text">
          </span>
        </div>
      </template>
    </notifications>

    <transition name="fade">
      <loading-came v-if="!$auth.ready()" :branding="true" :overlay="true"></loading-came>

      <div v-if="$auth.ready() && $auth.check()">

          <nav class="navbar navbar-expand-lg">

              <router-link to="/" class="navbar-brand">
                  <img v-if="isACS" src="../assets/logo-acs.svg" />
                  <div v-if="isACS" class="text-muted mt-n2" style="font-size:0.875rem;">ACS Cloud</div>
                  <img v-else src="../assets/logo.svg" />
              </router-link>
              <router-link to="/" class="navbar-brand">
                  <span class="product">Comms Manager</span>
              </router-link>

              <button class="navbar-toggler white ml-auto" type="button"
                      data-toggle="collapse" data-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="navbar-toggler-icon white">&#9776;</span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <nav-menu params="route: route"></nav-menu>
                  <div class="dropdown">
                      <button class="btn btn-outline-light dropdown-toggle" type="button" id="userDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{  $auth.user().user.displayName }}
                      </button>
                      <div class="dropdown-menu" aria-labelledby="userDropdownMenuButton">
                          <a class="dropdown-item usermenu-dropdown-item" href="#" @click.prevent="logout">Logout</a>
                      </div>
                  </div>
              </div>

          </nav>

        <div class="container main-container">
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </div>
      </div>

      <router-view v-else>
        Whoa, this should never be seen!
      </router-view>
    </transition>
  </div>
</template>

<script>
    require('bootstrap')

    import NavMenu from './nav-menu'
    import LoadingCame from 'common/components/loading-came'
    import { mapMutations, mapState } from 'vuex'
    import moment from 'moment'
    
    export default {
        data() {
            return {
                checkServerTimerHandle: null
            }
        },

        components: {
            'nav-menu': NavMenu,
            'loading-came': LoadingCame,
        },

        computed: {
             ...mapState({
                servers: state => state.servers
            })
        },

        methods: {
            logout: function () {
                this.$auth.logout({
                    makeRequest: false,
                    params: {},
                    success: () => this.$notify({ type: 'alert-success', text: 'Successfully logged out' }),
                    error: (response) => this.$notify({ type: 'alert-danger', title: 'Failed to logout', text: response.data.message }),
                    redirect: '/login',
                });
            },
            ...mapMutations([ 'addOrUpdateServer', 'addDebugLine', 'addrecentlyConnectedDevice' ]),

            signalRStart: function () {
                this.$commsEngineHub.invoke('registerInterestedAppHeartbeat');
            },

            handleCheckServerTimeout() {

                var timedOutServers = this.servers.filter(server => 
                    moment(server.lastSeen).isBefore(moment().subtract(20, 'seconds')));

                timedOutServers.forEach(server => server.timedout = true);
            },

            handleAppHeartbeat: function (message) {

                var logMessage = message;

                this.addDebugLine(logMessage);

                var type = logMessage.type || null;
               

                var server = {
                    name: logMessage.engineName || logMessage.loggerName,
                    ip: logMessage.engineName || logMessage.loggerName,
                    running_for: logMessage.runningFor,
                    started: logMessage.started,
                    type: type,
                    statistics: logMessage.statistics,
                    lastSeen: new Date()
                };


                this.addOrUpdateServer(server);

                if (logMessage.message && logMessage.message.indexOf("Connected ") !== -1)
                    this.addrecentlyConnectedDevice({ connected: true, message: logMessage.message });

                if (logMessage.message && logMessage.message.indexOf("Initialised ") !== -1)
                    this.addrecentlyConnectedDevice({ initialised: true, message: logMessage.message });

            },
            skLogMessageToLogModel: function (skLogMessageText) {

                var jsonMessage = JSON.parse(skLogMessageText);
                var jsonInnerMessage = null;

                try {
                    jsonInnerMessage = JSON.parse(jsonMessage.Message);
                }
                catch {
                    // do nothing
                }

                var htmlColour = '#ffffff';
                switch (jsonMessage.ConsoleColour) {
                    case 9: htmlColour = '#428bca'; break;
                    case 14: htmlColour = '#f0ad4e'; break;
                    case 8: htmlColour = '#999999'; break;
                    case 12: htmlColour = '#d9534f'; break;
                    case 2: htmlColour = '#5cb85c'; break;
                    case 7: htmlColour = '#cccccc'; break;
                }

                var logModel = {
                    message: jsonMessage.Message,
                    jsonMessage: jsonInnerMessage,
                    consoleColour: jsonMessage.ConsoleColour,
                    engineIdentifier: jsonMessage.EngineIdentifier,
                    deviceFriendlyName: jsonMessage.DeviceFriendlyName,
                    hexColour: htmlColour,
                }

                return logModel;
            },
        },

        created() {
            if (this.isACS) {
                document.documentElement.classList.add('acs');
                document.documentElement.classList.remove('skw');
            } else {
                document.documentElement.classList.add('skw');
                document.documentElement.classList.remove('acs');

            }

            document.documentElement.classList.add('light');
            document.documentElement.classList.remove('dark');
        },

        mounted: function () {
            this.$commsEngineHubStartRegistration(this.signalRStart.bind(this));

            this.$commsEngineHub.on('appHeartbeat', this.handleAppHeartbeat);

            this.checkServerTimerHandle = window.setInterval(this.handleCheckServerTimeout, 1000);
        },

        beforeDestroy() {
            this.$commsEngineHub.off('appHeartbeat', this.handleAppHeartbeat);
        },
    }

</script>

<style>

    #app {
        height: 100%;
    }

    .navbar {
        background-color: #000000 !important;
    }

    .navbar-brand img {
        height: 30px;
        margin-top: -12px;
    }
    .navbar-brand.router-link-active {
        color: #fff;
    }

    .navbar-toggler.white {
        border: 1px solid #fff;
        border-radius: 0;
        color: #fff;
        line-height: normal;
        vertical-align:central;
        font-size: 1rem;
    }
    button.navbar-toggler.white:hover {
        background-color: #fff;
        color: #000;
    }
    /*
    .navbar-toggler-icon.white {
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>");
    }
    span.navbar-toggler-icon.white:hover {
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(0, 0, 0, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>");
    }
        */

    .nav-link {
        font-family: 'came_type', -apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        color: #fff;
    }

    .router-link-active {
        font-weight: 700;
        color: #00b0ed;
    }
    a.nav-link:hover {
        color: #00b0ed;
    }

    div.dropdown {
        display: inline-block;
    }

    .main-container {
        margin-top: 30px;
    }

    .logo {
        font-family: webfont;
        font-size: 30px;
        line-height: 30px;
        margin-right: 10px;
    }

    .product {
        line-height: 30px;
        vertical-align: bottom;
        text-transform: uppercase;
        letter-spacing: 0.03rem;
        font-size: 1.5rem;
        font-family: 'came_type', -apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-weight: 500;
        text-transform: uppercase;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding-top: 0.2rem !important;
        display: inline-block;
        /*line-height: 0.5rem;
        
        letter-spacing: 0.04rem;*/
    }

    .usermenu-dropdown-item {
        color: #333 !important;
    }

    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

</style>
